import React from 'react';
import { withRemote } from '../../../Utils/Utils';
import PopupMenu from '../../PopupMenu';
import PopupMenuHeader from '../../popups/PopupMenuHeader';
import NotificationMenuItem from './NotificationMenuItem';

const NotificationMenu = ({ notifications, markAsRead, setActiveNotification }) => {
	const unreadNotifications = notifications && notifications.filter(n => !n.readAt).length
	return (
		<>
			<PopupMenu padding width="360px" maxHeight='70vh' noScrollBar>
				<PopupMenuHeader>{`Notifications${unreadNotifications > 0 ? " (" + unreadNotifications + ")" : ""}`}</PopupMenuHeader>
				{notifications.map((notification) => <NotificationMenuItem notification={notification} markAsRead={markAsRead} setActiveNotification={setActiveNotification}/>)}
			</PopupMenu>
		</>
	);
}

/* `export default withRemote(NotificationMenu);` is exporting the `NotificationMenu` component with additional
functionality provided by the `withRemote` higher-order component. The `withRemote` function is
likely enhancing the `NotificationMenu` component with remote data fetching capabilities or other
remote-related functionalities. This pattern is commonly used in React applications to enhance
components with additional features or data fetching logic without directly modifying the component
itself. */
export default withRemote(NotificationMenu);